import { ExclamationCircleIcon } from '@heroicons/react/outline';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { defaultModalStyles } from '@/components/Elements/Modal/customStyles';
import { PaymentsModal } from '@/components/Elements/PaymentsModal';
import { FormConfirm } from '@/components/Form/FormConfirm';
import { redirectMyRate } from '@/utils/helpers';

export type PaymentErrorModalProps = {
  titleTag: string;
  onRequestClose: () => void;
  isOpen?: boolean;
  shouldRedirect?: boolean;
};

export const PaymentErrorModal = ({
  titleTag,
  onRequestClose,
  isOpen = false,
  shouldRedirect = false,
}: PaymentErrorModalProps) => {
  const { t } = useTranslation();

  const onActionButton = () => {
    closeModal();
    shouldRedirect && redirectMyRate();
  };

  const closeModal = () => {
    onRequestClose && onRequestClose();
  };

  return (
    <PaymentsModal
      closeButton={false}
      isOpen={isOpen}
      style={defaultModalStyles}
      shouldCloseOnOverlayClick={false}
    >
      <FormConfirm
        title={t(titleTag)}
        description={t('PaymentForm.upgradeFailDescription')}
        actionButton={t('Forms.accept')}
        actionButtonIcon={false}
        image={<ExclamationCircleIcon width={100} className="m-auto text-red-900" />}
        onClickAction={onActionButton}
      />
    </PaymentsModal>
  );
};
